var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2243 3.0951C19.2884 2.01627 17.9075 1.33398 16.3672 1.33398C14.1845 1.33398 12.3217 2.7041 11.5921 4.63123C11.0464 4.38667 10.4414 4.25065 9.80469 4.25065C7.38845 4.25065 5.42969 6.20941 5.42969 8.62565C5.42969 8.65005 5.42989 8.6744 5.43028 8.6987M20.2243 3.0951C20.8479 2.8984 21.5119 2.79232 22.2005 2.79232C25.8249 2.79232 28.763 5.73045 28.763 9.35482C28.763 10.273 28.5745 11.1471 28.2339 11.9404M20.2243 3.0951C18.2602 3.71455 16.6952 5.23276 16.0115 7.16732C15.8473 7.63166 15.734 8.12 15.6781 8.62565M5.43028 8.6987C5.1945 8.65079 4.95045 8.62565 4.70052 8.62565C2.68699 8.62565 1.05469 10.258 1.05469 12.2715C1.05469 14.285 2.68699 15.9173 4.70052 15.9173H11.3359M5.43028 8.6987C5.44816 9.79057 5.86602 10.7851 6.54369 11.5423M28.2339 11.9404C27.7365 11.686 27.1727 11.5423 26.5755 11.5423C24.8117 11.5423 23.3403 12.7949 23.0026 14.459M28.2339 11.9404C29.4137 12.5442 30.2213 13.7718 30.2213 15.1881C30.2213 17.2017 28.589 18.834 26.5755 18.834C24.8115 18.834 23.5905 20.5959 24.2098 22.2476L25.1172 24.6673M11.3359 15.9173C11.6737 17.5814 13.145 18.834 14.9089 18.834C15.2804 18.834 15.4664 18.834 15.6377 18.8544C16.4919 18.9558 17.2578 19.4291 17.7304 20.1478C17.8254 20.2919 17.9085 20.4581 18.0746 20.7905L20.013 24.6673M11.3359 15.9173C11.2881 15.6816 11.263 15.4378 11.263 15.1881C11.263 13.9955 11.8357 12.9366 12.721 12.2715",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.7229c02e61a22ced016a7197a6a5dcd6.svg";
export { ForwardRef as ReactComponent };